export default "__VITE_ASSET__8c23cd96__"